import axios from 'axios'
import * as Config from '../config'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  authApi: {
    signUpUser: (data) => axios.post(Config.SIGN_UP_USER, data),
    signInUser: (data) => axios.post(Config.LOGIN_IN_OTP, data),
    userVerification: (data) => axios.post(Config.OTP, data),
  },
  doctor: {
    doctorDetails: (id) => instance.get(`${Config.DOCTOR}${id}`),
    bookAppointment: (data) =>
      instance.post(
        `${Config.BOOK_APPOINTMENT}${data?.doctor_id}?appointment_date=${data?.appointment_date}?visit_type_id=${data?.visit_type_id}?slot_type_id=${data?.slot_type_id}?status_type_id=${data?.status_type_id}`,
      ),
    getDoctorSlots: (doctor_id, visit_type_id) =>
      instance.get(
        `${Config.DOCTOR_SLOT_LIST}?doctor_id=${doctor_id}&visit_type_id=${visit_type_id}`,
      ),
  },
}
